import Vue from 'vue';
import { assign } from 'lodash';
import { updateArrayItemByID, removeArrayItemByID } from 'utils/array';
import * as api from 'api/api-stuff-to-eat';
import * as types from '../mutation-types';


const initState = {
  ready: false,
  fetching: false,
  fetched: false,
  search: false,
  error: null,
  saving: false,
  saveError: false,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  StuffToEatExchanges: state => id => state[id],
};

const actions = {
  GetStuffToEatExchanges({ commit }, params) {
    const id = params.id;
    const type = params.type;
    commit(types.FETCH_STUFF_TO_EAT_EXCHANGES_START, { id });
    api.getExchanges(
      type,
      id,
      (response) => {
        commit(types.RECEIVE_STUFF_TO_EAT_EXCHANGES, { id, response });
      },
      (description, status, error) => {
        commit(types.FETCH_STUFF_TO_EAT_EXCHANGES_ERROR, { id, error });
      },
    );
  },
  AddStuffToEatExchangeToExchangeList({ commit }, { id, response }) {
    commit(types.ADD_STUFF_TO_EAT_EXCHANGE_TO_EXCHANGE_LIST, { id, response });
  },
  EditStuffToEatExchangeInExchangeList({ commit }, { id, response }) {
    commit(types.EDIT_STUFF_TO_EAT_EXCHANGE_IN_EXCHANGE_LIST, { id, response });
  },
  RemoveStuffToEatExchangeFromExchangeList({ commit }, { id, entityExchangeID }) {
    commit(types.REMOVE_STUFF_TO_EAT_EXCHANGE_FROM_EXCHANGE_LIST, { id, entityExchangeID });
  },
  ClearStuffToEatExchanges({ commit }, id) {
    commit(types.CLEAR_STUFF_TO_EAT_EXCHANGES, { id });
  },
};

const mutations = {
  [types.FETCH_STUFF_TO_EAT_EXCHANGES_START](state, { id }) {
    console.log('FETCH_STUFF_TO_EAT_EXCHANGES_START');
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_STUFF_TO_EAT_EXCHANGES_ERROR](state, { id, error }) {
    console.log('FETCH_STUFF_TO_EAT_EXCHANGES_ERROR');
    Vue.set(state, id, assign({}, neutralState, { error }));
  },
  [types.RECEIVE_STUFF_TO_EAT_EXCHANGES](state, { id, response }) {
    console.log('RECEIVE_STUFF_TO_EAT_EXCHANGES', response);
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, meta: response.meta, data: response.data }));
  },
  [types.ADD_STUFF_TO_EAT_EXCHANGE_TO_EXCHANGE_LIST](state, { id, response }) {
    console.log('ADD_STUFF_TO_EAT_EXCHANGE_TO_EXCHANGE_LIST', id, response);
    if (state[id]) state[id].data.push(response.data);
  },
  [types.EDIT_STUFF_TO_EAT_EXCHANGE_IN_EXCHANGE_LIST](state, { id, response }) {
    console.log('EDIT_STUFF_TO_EAT_EXCHANGE_IN_EXCHANGE_LIST', id, response.data);
    if (state[id]) updateArrayItemByID(state[id].data, response.data);
  },
  [types.REMOVE_STUFF_TO_EAT_EXCHANGE_FROM_EXCHANGE_LIST](state, { id, entityExchangeID }) {
    console.log('REMOVE_STUFF_TO_EAT_EXCHANGE_FROM_EXCHANGE_LIST', id, entityExchangeID);
    if (state[id]) removeArrayItemByID(state[id].data, entityExchangeID);
  },
  [types.CLEAR_STUFF_TO_EAT_EXCHANGES](state, { id }) {
    console.log('CLEAR_STUFF_TO_EAT_EXCHANGES');
    Vue.delete(state, id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-eat/entities/stuff-to-eat-exchanges.js